import * as React from "react";
import { useEffect } from "react";
import { Text } from "../../Text";
import { useTranslation } from "react-i18next";
import "./authViewStyles.css";
import "../../../styles/sprite.css";
import { LanguageChangeButton } from "../../LanguageChangeButton";
import { useRouter } from "../../../context/Router";
import { focusManager } from "../../../utils/Focus";
import { AuthBackButtonView } from "./AuthBackButtonView";
export var AuthView = function (_a) {
    var codeStart = _a.codeStart, codeEnd = _a.codeEnd, minutes = _a.minutes, seconds = _a.seconds;
    var t = useTranslation().t;
    var params = useRouter().params;
    useEffect(function () {
        focusManager.registerGroup({ name: "caveaAuth", position: 1 });
        focusManager.manualFocus("caveaAuth", 1);
    }, []);
    return (React.createElement("div", { className: "container", id: "cavea-auth" },
        React.createElement("div", { className: "content-container" },
            React.createElement("p", { className: "title" }, t("quick-auth.title")),
            React.createElement("div", { className: "auth-section-container" },
                React.createElement("div", { className: "qr-code-container" }),
                React.createElement("h2", { className: "url-text" }, "cavea.plus/tv")),
            React.createElement("div", { className: "code-container" },
                React.createElement("p", { className: "code-title" }, t("quick-auth.enter-code")),
                React.createElement(Text, { className: "code" },
                    codeStart,
                    " ",
                    codeEnd),
                React.createElement("div", { className: "timer-container" },
                    React.createElement("div", { className: "clock-icon" },
                        React.createElement("div", { className: "time-circle" })),
                    React.createElement(Text, { className: "timer" },
                        minutes,
                        ":",
                        seconds))),
            React.createElement("div", { className: "button-container" },
                React.createElement(LanguageChangeButton, { focusRaw: ["caveaAuth", 0], authScreen: true }),
                params.silkUserExists && (React.createElement(AuthBackButtonView, { focusRaw: ["caveaAuth", 1] }))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/auth/AuthView.tsx
// module id = 169
// module chunks = 1